module.exports = __webpack_public_path__ + "img/purple-3-squiggly-striped.8ac5b5c7.svg";